export const data = [
  {
    title: "ISO 9001 – 2015 – Quality",
    link: "https://cdn.fashionbiz.com/bizz-react/corporate-social-responsibility/Fashion Biz (AUST) MSCG ISO 9001-2015 QUALITY Certificate 2023.pdf",
  },
  {
    title: "ISO 14001 – 2015 – Environmental",
    link: "https://cdn.fashionbiz.com/bizz-react/corporate-social-responsibility/Fashion Biz (AUST) MSCG ISO 14001-2015 ENVIRONMENTAL Certificate 2023.pdf",
  },
  {
    title: "ISO 45001 -2018 - Safety",
    link: "https://cdn.fashionbiz.com/bizz-react/corporate-social-responsibility/Fashion Biz (AUST) MSCG ISO 45001-2018 OH&SMS Certificate 2023.pdf",
  },
];
